import type {
  DocumentTypeDomain,
  DocumentTypeRecurrenceAnchor,
} from '@shared/dto/document-type/document-type-catalog.constants';
import { inject } from 'inversify';
import { Injectable } from '../../decorators/injectable';
import { HttpService, type IHttpService } from '../http/http.service';

export interface DocumentTypeItem {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  domain: DocumentTypeDomain | null;
  defaultValidityMonths: number | null;
  defaultWarningDays: number[];
  recurrenceAnchor: DocumentTypeRecurrenceAnchor | null;
  warningOnly: boolean;
  isPersonal: boolean;
  legalRefUrl: string | null;
  catalogKey: string | null;
  sortOrder: number;
  _count: { documents: number };
}

export interface IDocumentTypeService {
  findAll(): Promise<DocumentTypeItem[]>;
}

@Injectable()
class DocumentTypeService implements IDocumentTypeService {
  constructor(@inject(HttpService) private readonly http: IHttpService) {}

  async findAll(): Promise<DocumentTypeItem[]> {
    return this.http.get<DocumentTypeItem[]>('document-types');
  }
}

export { DocumentTypeService };
